module.exports = __webpack_public_path__ + "static/media/logo1.3b01fe9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo1.png
// module id = 662
// module chunks = 0 1